'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'stories';
var width = 30;
var height = 30;
var ligatures = [];
var unicode = 'fc001'; //increment this for next icons
var svgPathData =
  'M20.6898784,26.3933985 L21.9376108,27.9829182 C19.8550099,29.0726316 17.4817035,29.6895414 14.9630542,29.6895414 C13.3460658,29.6895414 11.7889836,29.4352685 10.3302732,28.9648556 L11.1190661,27.137515 C12.3336831,27.5107146 13.6246918,27.7117079 14.9630542,27.7117079 C17.0187965,27.7117079 18.9628155,27.237497 20.6898784,26.3933985 Z M8.54310756,26.0283009 L7.75413207,27.8576248 C5.24283493,26.4862702 3.17151541,24.4206521 1.8033509,21.9216737 L3.56797066,20.9977725 C4.72228309,23.0980406 6.45020115,24.8438216 8.54310756,26.0283009 Z M14.9630542,0.0220391327 C23.2269208,0.0220391327 29.9261084,6.66333573 29.9261084,14.8557903 C29.9261084,19.5401938 27.7358132,23.7174471 24.3151088,26.4359593 L23.0896637,24.8748167 C26.0419513,22.5183753 27.9310345,18.9057859 27.9310345,14.8557903 C27.9310345,7.755663 22.1250719,1.99987262 14.9630542,1.99987262 C14.796105,1.99987262 14.6298927,2.00300016 14.4644736,2.00919936 L14.4645359,0.0301167177 C14.6300428,0.0247456195 14.7962297,0.0220391327 14.9630542,0.0220391327 Z M0.207910434,12.3774483 L2.13752262,12.9437459 C2.04369347,13.5675827 1.99507389,14.2060577 1.99507389,14.8557903 C1.99507389,16.0836865 2.1687201,17.271376 2.4929961,18.3960411 L0.695226347,19.3380272 C0.243610406,17.9238863 0,16.4180415 0,14.8557903 C0,14.0113373 0.0711778767,13.1833651 0.207910434,12.3774483 Z M3.0404395,5.89132983 L4.58037843,7.15193902 C3.87229771,8.08831219 3.29009281,9.1236201 2.85865328,10.2331883 L0.939646799,9.67045152 C1.45397382,8.30400382 2.1656999,7.03293379 3.0404395,5.89132983 Z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData]
};

exports.faStories = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
